import {
  Button,
  getPrimaryColor,
  isMobileAtom,
  Modal,
  Styles,
  useRecoil,
} from '@orcar/common-d2c';
import styled from 'styled-components';
import { app } from '@/constants/common';

type LongTermEstimationModalProps = {
  onClose: () => void;
  onClick: () => void;
  vehicleImgUrl: string;
  vehicleModelName: string;
  monthPrice?: number;
};

const LongTermEstimationModal = ({
  onClose,
  onClick,
  vehicleImgUrl,
  vehicleModelName,
  monthPrice,
}: LongTermEstimationModalProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  return (
    <Modal
      paddingHorizontal={20}
      paddingVertical={isMobile ? 20 : 30}
      onClose={onClose}
      hasClose={!isMobile}
      topLevel
      hasBorder={false}
    >
      <Wrapper isMobile={isMobile}>
        <InnerWrapper>
          <Text font={Styles.NEW_FONT.H4} padding='0 0 20px 0'>
            선택한 차량
          </Text>
          <ContentWrapper>
            <img src={vehicleImgUrl} width={'100%'} alt='선택한 차량' />
            <FlexColumnWrapper padding='8px 20px' gap={8}>
              <Text fontSize={16} fontWeight={600}>
                {vehicleModelName}
              </Text>
              <Text fontSize={20} fontWeight={700} color={getPrimaryColor(app)}>
                {monthPrice
                  ? `월 ${monthPrice.toLocaleString()}원~`
                  : '상담 후 결정'}
              </Text>
            </FlexColumnWrapper>
          </ContentWrapper>
          <Text
            fontSize={16}
            color={Styles.COLOR.GREY_02}
            padding='20px 16px'
            lineHeight={1.5}
          >
            정확한 가격은 상담 후 결정됩니다. <br />
            <span
              style={{
                fontWeight: 700,
              }}
            >
              043-260-1116
            </span>{' '}
            으로 연락주시면 견적 상담을 도와드리겠습니다.
          </Text>
        </InnerWrapper>
        <Button
          height='40px'
          borderRadius='5px'
          onClick={onClick}
          font={Styles.NEW_FONT.B1}
        >
          확인
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default LongTermEstimationModal;

const FlexColumnWrapper = styled.div<{
  gap?: number;
  padding?: string;
  backgroundColor?: string;
  borderRadius?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || 0}px;
  padding: ${({ padding }) => padding || '0'};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
  border-radius: ${({ borderRadius }) => borderRadius || '0'};
`;

const Wrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${({ isMobile }) => (isMobile ? '300px' : '400px')};
  gap: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  border-radius: 10px;
  padding: 12px 0;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled.p<{
  font?: Record<string, string>;
  fontSize?: number;
  fontWeight?: number;
  color?: string;
  padding?: string;
  lineHeight?: number;
}>`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '16px')};
  font-weight: ${({ fontWeight }) => (fontWeight ? `${fontWeight}` : '400')};
  line-height: ${({ lineHeight }) => lineHeight || 'normal'};
  ${({ font }) => font && font};
  color: ${({ color, theme }) => color || theme.COLOR.GREY_01};
  padding: ${({ padding }) => padding || '0'};
  white-space: pre-wrap;
`;
